<template>
  <div class="main">
    <b-overlay
      :show="blockingLoader"
      spinner-small="true"
      variant="primary"
      opacity="0.8"
    >
      <div class="d-flex justify-content-center" v-if="loadingSpinner">
        <b-spinner
          variant="success"
          label="Spinning"
          style="width: 3rem; height: 3rem"
        ></b-spinner>
      </div>

      <div v-if="!loadingSpinner">
        <form-wizard
          color="#B1D06C"
          :title="null"
          :subtitle="null"
          shape="square"
          finish-button-text="Submit"
          back-button-text="Previous"
          class="mb-3"
          @on-complete="formSubmitted"
        >
          <!-- accoint details tab -->

          <tab-content title="Lead Details">
            <b-tabs pills v-on:input="getValue($event)">
              <b-tab title="Individual" active>
                <b-card-text>
                  <b-card title="Add Individual">
                    <AddLead
                      @update:individual="updateIndividual"
                      :individual="individual"
                      ref="addLeadProfile"
                    />
                  </b-card>
                </b-card-text>
              </b-tab>
              <b-tab title="Company">
                <b-card-text>
                  <b-card title="Add Company">
                    <AddCompany
                      @update:company="updateCompany"
                      :company="company"
                      ref="addCompanyProfile"
                    />
                  </b-card>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </tab-content>
        </form-wizard>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  customLoader,
  numericValidation,
  customErrorMessage,
} from "@/libs/customFn";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BTab,
  BCard,
  BCardText,
  BContainer,
  BSpinner,
  BTabs,
} from "bootstrap-vue";
import AddCompany from "./AddCompany.vue";
import AddLead from "./AddLead.vue";
import { mapActions, mapGetters } from "vuex";
import { customError, customSwal } from "@/libs/customFn";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    BCardText,
    TabContent,
    BRow,
    BContainer,
    BCol,
    BSpinner,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    ToastificationContent,
    AddCompany,
    AddLead,
    BTab,
    BCard,
    BTabs,
  },
  data() {
    return {
      blockingLoader: false,
      loadingSpinner: true,
      individual: {
        lName: null,
        fName: null,
        email: null,
        dob: null,
        addressLine1: null,
        addressLine2: null,
        tel: null,
        fieldInstruction: null,
        title: null,
        comments: null,
        salesPersonId: null,
        profile: {
          source: null,
          city: null,
          jobTitle: null,
          hobbies: [],
          productsInterestedIn: [],
          marketingSegments: [],
        },
        percentage: 0,
        additionalFields: [],
      },

      company: {
        companyName: null,
        otherName: null,
        email: null,
        brn: null,
        addressLine1: null,
        addressLine2: null,
        tel: null,
        fieldInstruction: null,
        website: null,
        vatNumber: null,
        comments: null,
        salesPersonId: null,
        profile: {
          source: null,
          city: null,
          productsInterestedIn: [],
          marketingSegments: [],
        },
        percentage: 0,
        additionalFields: [],
      },

      valueCheck: null,
    };
  },
  computed: {
    ...mapGetters("leadModule", {
      loading: "loading",
    }),
    otherName() {
      return this.individual.fName + " " + this.individual.lName;
    },
  },

  mounted() {
    setTimeout(() => (this.loadingSpinner = false), 2000);
  },
  methods: {
    ////////
    ...mapActions("leadModule", ["addLeadAction"]),

    getValue(value) {
      this.valueCheck = value;
    },

    updateIndividual(individualData) {
      //console.log(details);
      this.individual.fName = individualData.fName;
      this.individual.lName = individualData.lName;
      this.individual.email = individualData.email;
      this.individual.dob =
        individualData.dob != "" ? individualData.dob : null;
      this.individual.addressLine1 = individualData.addressLine1;
      this.individual.addressLine2 = individualData.addressLine2;
      this.individual.tel = individualData.tel;
      this.individual.fieldInstruction = individualData.fieldInstruction;
      this.individual.title = individualData.title;
      this.individual.comments = individualData.comments;
      this.individual.salesPersonId = individualData.salesPersonId;
      this.individual.profile.source = individualData.profile.source;
      this.individual.profile.city = individualData.profile.city;
      // Extract hobbies array
      this.individual.profile.hobbies = individualData.profile.hobbies.map(
        (hobby) => hobby.value
      );

      // Extract productsInterestedIn array
      this.individual.profile.productsInterestedIn =
        individualData.profile.productsInterestedIn.map(
          (product) => product.value
        );
      this.individual.profile.jobTitle = individualData.profile.jobTitle;
      // extracting segment
      this.individual.profile.marketingSegments =
        individualData.profile.marketingSegments.map(
          (segment) => segment.value
        );
      this.individual.percentage = individualData.percentage;
      this.individual.additionalFields = individualData.additionalFields;
    },

    updateCompany(companyData) {
      // console.log(companyData);
      this.company.companyName = companyData.companyName;
      this.company.otherName = companyData.otherName;
      this.company.email = companyData.email;
      this.company.addressLine1 = companyData.addressLine1;
      this.company.addressLine2 = companyData.addressLine2;
      this.company.profile.city = companyData.city;
      this.company.tel = companyData.tel;
      this.company.fieldInstruction = companyData.fieldInstruction;
      this.company.website = companyData.website;
      this.company.brn = companyData.brn;
      this.company.vatNumber = companyData.vatNumber;
      this.company.comments = companyData.comments;
      this.company.salesPersonId = companyData.salesPersonId;
      this.company.profile.source = companyData.profile.source;
      this.company.profile.city = companyData.profile.city;
      // Extract productsInterestedIn array
      this.company.profile.productsInterestedIn =
        companyData.profile.productsInterestedIn.map(
          (product) => product.value
        );
      // extracting segment
      this.company.profile.marketingSegments =
        companyData.profile.marketingSegments.map((segment) => segment.value);

      this.company.percentage = companyData.percentage;
      this.company.additionalFields = companyData.additionalFields;
    },
    async formSubmitted() {
      if (!this.blockingLoader) {
        if (this.valueCheck == 0) {
          await this.addLeadsIndividual();
        } else {
          await this.addLeadsCompany();
        }
      }
    },

    success(response) {
      console.log("🚀 ~ success ~ response:", response);
      this.$swal({
        title: "Leads!",
        text: "You have successfully added the lead!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            title: "Do you want a quotation?",
            showDenyButton: true,
            confirmButtonText: "YES",
            denyButtonText: "NO",
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push("/quotation/add/" + response.result.id);
            } else if (result.isDenied) {
              this.$router.push({ name: "leads-list" });
            }
          });
        }
      });
    },

    // error
    error(err) {
      this.$swal({
        title: "Error!",
        html: `<p>Failed:<br><strong>${err.message}</strong></p> . This email already has been used.`,
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        
        buttonsStyling: false,
      });
    },

    async addLeadsIndividual() {
      const loader = customLoader("Please wait while we save your lead.");

      this.blockingLoader = true; // Enable loader
      try {
        let isValid = await this.$refs.addLeadProfile.submitForm();

        if (isValid) {
          let payload = {
            otherName: this.individual.fName,
            surname: this.individual.lName,
            email: this.individual.email,
            addressLine1: this.individual.addressLine1,
            addressLine2: this.individual.addressLine2,
            tel: this.individual.tel,
            fieldInstruction: this.individual.fieldInstruction,
            title: this.individual.title,
            comments: this.individual.comments,
            dob: this.individual.dob != "" ? this.individual.dob : null,
            type: 0,
            status: 0,
            salesPersonId: this.individual.salesPersonId,
            profile: {
              source: this.individual.profile.source,
              city: this.individual.profile.city,
              jobTitle: this.individual.profile.jobTitle,
              hobbies: this.individual.profile.hobbies.map(
                (hobby) => hobby.value
              ),
              productsInterestedIn:
                this.individual.profile.productsInterestedIn != []
                  ? this.individual.profile.productsInterestedIn.map(
                      (product) => product.value
                    )
                  : [],
              marketingSegments: this.individual.profile.marketingSegments.map(
                (segment) => segment.value
              ),
            },
            percentage: this.individual.percentage,
            additionalFields: this.individual.additionalFields,
          };
          const response = await this.addLeadAction(payload);
          loader.close();
          this.success(response);
        }
      } catch (err) {
        loader.close();
        this.error(err);
        console.error("Error adding individual lead:", err);
      } finally {
        loader.close();
        this.blockingLoader = false;
      }
    },

    async addLeadsCompany() {
      const loader = customLoader("Please wait while we save your lead.");
      this.blockingLoader = true;
      try {
        let isValid = await this.$refs.addCompanyProfile.submitForm();

        console.log(await this.$refs.addCompanyProfile.submitForm());

        console.log(isValid, this.company);
        if (isValid) {
          let payload = {
            otherName: this.company.otherName,
            email: this.company.email,
            companyName: this.company.companyName,
            addressLine1: this.company.addressLine1,
            addressLine2: this.company.addressLine2,
            tel: this.company.tel,
            fieldInstruction: this.company.fieldInstruction,
            website: this.company.website,
            brn: this.company.brn,
            vatNumber: this.company.vatNumber,
            comments: this.company.comments,
            salesPersonId: this.company.salesPersonId,
            type: 1,
            status: 0,
            isActive: true,
            profile: {
              source: this.company.profile.source,
              city: this.company.profile.city,
              productsInterestedIn:
                this.company.profile.productsInterestedIn != []
                  ? this.company.profile.productsInterestedIn.map(
                      (product) => product.value
                    )
                  : [],
              marketingSegments: this.company.profile.marketingSegments.map(
                (segment) => segment.value
              ),
            },
            percentage: this.company.percentage,
            additionalFields: this.company.additionalFields,
          };

          const response = await this.addLeadAction(payload);
          loader.close();
          this.success(response);
        }
      } catch (err) {
        loader.close();
        this.error(err);
        console.error("Error adding company lead:", err);
      } finally {
        loader.close();
        this.blockingLoader = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";

.dropdown-toggle {
  text-align: left;
}
</style>
